import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { Title } from "../Components/Channel/Title/Title";
import { TabsMenu } from "../Components/Channel/Tabs/Tabs";
import { Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getSingleChannel } from "../Store/Features/SingleChannel/SingleChannelSlice";
import { useParams } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
export const ChannelDetail = () => {
  const { slug } = useParams();
  const dispatch = useDispatch();
  const Channel = useSelector(state => state.singleChannelSlice.value);
  const Loading = useSelector(state => state.singleChannelSlice.loading);
  useEffect(() => {
    dispatch(getSingleChannel(slug));
  }, []);
  return (
    <Box className="main_container">
      {Loading ? (<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", justifyContent: "center", height: "40vh" }} > <CircularProgress /></Box >) : (
        <>
          <Title channel={Channel?.name} Username={Channel?.created_by?.name} />
          <TabsMenu />
          <Outlet />
        </>
      )
      }

    </Box >
  );
};